import { AML_STATUS_QUERY, GRACE_PERIOD_QUERY, ACCOUNT_IS_PROCESSING_STATUS_QUERY, USER_LOGGED_IN_UPDATED, UPDATE_AML_STATUS, AML_STATUS_UPDATED, GRACE_PERIOD_UPDATED, ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { AmlStatus } from '@gig/magic-sdk/dist/adapter/users/getAmlStatus';

var AmlService = /** @class */ (function () {
    function AmlService() {
        var _this = this;
        this.isLoggedIn = false;
        this.amlStatus = null;
        this.amlQuerySubscription = null;
        this.gracePeriodSubscription = null;
        this.gracePeriod = [];
        this.subscriptions = [];
        this.loading = false;
        this.userBlocksSubscription = null;
        this.isProcessing = false;
        this.amlHandler = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.loading) {
                            return [2 /*return*/];
                        }
                        this.unsubscribeQueries();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.loading = true;
                        return [4 /*yield*/, Promise.all([
                                this.updateAmlStatus(),
                                this.updateGracePeriod(),
                            ])];
                    case 2:
                        _a.sent();
                        this.setIsProcessing();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        // eslint-disable-next-line no-console
                        console.log('unable to update aml status', e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        this.registerQueryHandlers();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.registerEvents();
        this.subscribeToUserLoginChanges();
        this.subscribeUpdateAmlCommand();
    }
    AmlService.prototype.registerQueryHandlers = function () {
        var _this = this;
        this.amlQuerySubscription = window.queryBus.subscribe(AML_STATUS_QUERY, function () {
            return _this.amlStatus;
        });
        this.gracePeriodSubscription = window.queryBus.subscribe(GRACE_PERIOD_QUERY, function () {
            return _this.gracePeriod;
        });
        this.userBlocksSubscription = window.queryBus.subscribe(ACCOUNT_IS_PROCESSING_STATUS_QUERY, function () {
            return _this.isLoggedIn && _this.isProcessing;
        });
    };
    AmlService.prototype.unsubscribeQueries = function () {
        var _a, _b, _c;
        (_a = this.amlQuerySubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.gracePeriodSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.userBlocksSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
        this.amlQuerySubscription = null;
        this.gracePeriodSubscription = null;
        this.userBlocksSubscription = null;
    };
    AmlService.prototype.subscribeToUserLoginChanges = function () {
        var _this = this;
        window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoggedIn = !!e.payload;
                        return [4 /*yield*/, this.amlHandler()];
                    case 1:
                        _a.sent();
                        if (this.isLoggedIn) {
                            this.subscribeToMagicEvents();
                        }
                        else {
                            this.clearMagicSubscriptions();
                        }
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    AmlService.prototype.subscribeToMagicEvents = function () {
        this.subscriptions.push(magic.events.firstDeposit(this.amlHandler).unsub, magic.events.subsequentDeposit(this.amlHandler).unsub, magic.events.KYCStatusUpdated(this.amlHandler).unsub, magic.events.withdrawStatusChanged(this.amlHandler).unsub, magic.events.userBlockStatusChanged(this.amlHandler).unsub);
    };
    AmlService.prototype.clearMagicSubscriptions = function () {
        this.subscriptions.forEach(function (unsub) { return unsub(); });
        this.subscriptions = [];
    };
    AmlService.prototype.subscribeUpdateAmlCommand = function () {
        var _this = this;
        window.commandBus.subscribe(UPDATE_AML_STATUS, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.amlHandler()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AmlService.prototype.setIsProcessing = function () {
        // If we know the KYC status we can display some notifications to the user to
        // explain what their status is.
        this.isProcessing = false;
        if (!this.amlStatus) {
            return;
        }
        var status = this.amlStatus.status;
        var processing = AmlStatus.PROCESSING;
        var disallowed = [
            AmlStatus.PENDING,
            AmlStatus.PENDING_REQUEST,
            AmlStatus.REQUESTED,
            AmlStatus.USER_REQUESTED,
            processing,
            AmlStatus.REJECTED,
        ];
        if (disallowed.includes(status.photoID) ||
            disallowed.includes(status.address)) {
            this.isProcessing =
                status.photoID === processing || status.address === processing;
        }
    };
    AmlService.prototype.registerEvents = function () {
        window.queryBus.register(AML_STATUS_QUERY, {
            type: 'object',
        });
        window.queryBus.register(GRACE_PERIOD_QUERY, {
            type: 'array',
        });
        window.eventBus.register(AML_STATUS_UPDATED, {
            type: ['object', 'null'],
        });
        window.eventBus.register(GRACE_PERIOD_UPDATED, {
            type: 'array',
        });
    };
    AmlService.prototype.updateAmlStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isPepBlocked, _a, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isLoggedIn) {
                            this.amlStatus = null;
                            window.eventBus.publish(AML_STATUS_UPDATED, this.amlStatus);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY)];
                    case 1:
                        isPepBlocked = _b.sent();
                        if (isPepBlocked) {
                            return [2 /*return*/];
                        }
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        _a = this;
                        return [4 /*yield*/, magic.methods.users.getAmlStatus()];
                    case 3:
                        _a.amlStatus = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_2 = _b.sent();
                        console.error('aml status fetch failed');
                        return [3 /*break*/, 5];
                    case 5:
                        window.eventBus.publish(AML_STATUS_UPDATED, this.amlStatus);
                        return [2 /*return*/];
                }
            });
        });
    };
    AmlService.prototype.updateGracePeriod = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isLoggedIn) {
                            this.gracePeriod = [];
                            window.eventBus.publish(GRACE_PERIOD_UPDATED, this.gracePeriod);
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, magic.methods.users.getGracePeriods()];
                    case 2:
                        _a.gracePeriod = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _b.sent();
                        console.error('grace period fetch failed');
                        return [3 /*break*/, 4];
                    case 4:
                        window.eventBus.publish(GRACE_PERIOD_UPDATED, this.gracePeriod);
                        return [2 /*return*/];
                }
            });
        });
    };
    return AmlService;
}());

export { AmlService };
